var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_174",
    "data-name": "Group 174",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.386,
    height: 23.369,
    viewBox: "0 0 24.386 23.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 24.387,
    height: 23.369,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M16.806,14.809h2.7a.7.7,0,0,1,.719.679v2.783a.7.7,0,0,1-.719.679h-2.7a.7.7,0,0,1-.719-.679V15.488A.7.7,0,0,1,16.806,14.809Zm-5.964,0h2.7a.7.7,0,0,1,.719.679v2.783a.7.7,0,0,1-.719.679h-2.7a.7.7,0,0,1-.719-.679V15.488A.7.7,0,0,1,10.842,14.809Zm-5.964,0h2.7a.7.7,0,0,1,.719.679v2.783a.7.7,0,0,1-.719.679h-2.7a.7.7,0,0,1-.719-.679V15.488A.7.7,0,0,1,4.878,14.809ZM16.806,8.844h2.7a.7.7,0,0,1,.719.679v2.783a.7.7,0,0,1-.719.679h-2.7a.7.7,0,0,1-.719-.679V9.523a.7.7,0,0,1,.719-.679m-5.964,0h2.7a.7.7,0,0,1,.719.679v2.783a.7.7,0,0,1-.719.679h-2.7a.7.7,0,0,1-.719-.679V9.523a.7.7,0,0,1,.719-.679M5.934,0A1.072,1.072,0,0,0,4.861,1.073v.795H2.617A2.653,2.653,0,0,0,0,4.566V20.671a2.652,2.652,0,0,0,2.617,2.7H21.77a2.653,2.653,0,0,0,2.617-2.7V4.567a2.652,2.652,0,0,0-2.617-2.7H19.526V2.71a1.9,1.9,0,0,1-2.154,1.848V1.073A1.072,1.072,0,0,0,16.3,0H14.963A1.072,1.072,0,0,0,13.89,1.073v.795H10.5V2.71A1.9,1.9,0,0,1,8.343,4.558V1.073A1.072,1.072,0,0,0,7.27,0H5.934Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarB);
export default __webpack_public_path__ + "static/media/calendar-b.b2d8dd0c4bce3cde1170c6dc3c295a9b.svg";
export { ForwardRef as ReactComponent };